export var RmRatingDetailsMapper = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var ratingData = [];
    data.map(function (x) {
        ratingData = Object.entries(x).map(function (key, value) {
            return {
                title: key[0],
                data: key[1],
            };
        });
    });
    var objIndexstrength = ratingData.findIndex(function (obj) { return obj.title === "strength"; });
    ratingData[objIndexstrength].title = "Strengths";
    if (ratingData[objIndexstrength].data && ((_a = ratingData[objIndexstrength].data) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = ratingData[objIndexstrength].data[0]) === null || _b === void 0 ? void 0 : _b.oldRatingDate)) {
        ratingData[objIndexstrength].oldRatingDate = (_c = ratingData[objIndexstrength].data[0]) === null || _c === void 0 ? void 0 : _c.oldRatingDate;
    }
    else {
        ratingData[objIndexstrength].oldRatingDate = "";
    }
    if (ratingData[objIndexstrength].data && ((_d = ratingData[objIndexstrength].data) === null || _d === void 0 ? void 0 : _d.length) > 0 && ((_e = ratingData[objIndexstrength].data[0]) === null || _e === void 0 ? void 0 : _e.currentRatingDate)) {
        ratingData[objIndexstrength].currentRatingDate = (_f = ratingData[objIndexstrength].data[0]) === null || _f === void 0 ? void 0 : _f.currentRatingDate;
    }
    else {
        ratingData[objIndexstrength].currentRatingDate = "";
    }
    var objIndexareaimprovent = ratingData.findIndex(function (obj) { return obj.title === "areaimprovement"; });
    ratingData[objIndexareaimprovent].title = "Opportunity";
    if (ratingData[objIndexareaimprovent].data && ((_g = ratingData[objIndexareaimprovent].data) === null || _g === void 0 ? void 0 : _g.length) > 0 && ((_h = ratingData[objIndexareaimprovent].data[0]) === null || _h === void 0 ? void 0 : _h.oldRatingDate)) {
        ratingData[objIndexareaimprovent].oldRatingDate = (_j = ratingData[objIndexareaimprovent].data[0]) === null || _j === void 0 ? void 0 : _j.oldRatingDate;
    }
    else {
        ratingData[objIndexareaimprovent].oldRatingDate = "";
    }
    if (ratingData[objIndexareaimprovent].data && ((_k = ratingData[objIndexareaimprovent].data) === null || _k === void 0 ? void 0 : _k.length) > 0 && ((_l = ratingData[objIndexareaimprovent].data[0]) === null || _l === void 0 ? void 0 : _l.currentRatingDate)) {
        ratingData[objIndexareaimprovent].currentRatingDate = (_m = ratingData[objIndexareaimprovent].data[0]) === null || _m === void 0 ? void 0 : _m.currentRatingDate;
    }
    else {
        ratingData[objIndexareaimprovent].currentRatingDate = "";
    }
    var objIndexweakness = ratingData.findIndex(function (obj) { return obj.title === "weakness"; });
    ratingData[objIndexweakness].title = "Weakness";
    if (ratingData[objIndexweakness].data && ((_o = ratingData[objIndexweakness].data) === null || _o === void 0 ? void 0 : _o.length) > 0 && ((_p = ratingData[objIndexweakness].data[0]) === null || _p === void 0 ? void 0 : _p.oldRatingDate)) {
        ratingData[objIndexweakness].oldRatingDate = (_q = ratingData[objIndexweakness].data[0]) === null || _q === void 0 ? void 0 : _q.oldRatingDate;
    }
    else {
        ratingData[objIndexweakness].oldRatingDate = "";
    }
    if (ratingData[objIndexweakness].data && ((_r = ratingData[objIndexweakness].data) === null || _r === void 0 ? void 0 : _r.length) > 0 && ((_s = ratingData[objIndexweakness].data[0]) === null || _s === void 0 ? void 0 : _s.currentRatingDate)) {
        ratingData[objIndexweakness].currentRatingDate = (_t = ratingData[objIndexweakness].data[0]) === null || _t === void 0 ? void 0 : _t.currentRatingDate;
    }
    else {
        ratingData[objIndexweakness].currentRatingDate = "";
    }
    return { data: ratingData };
};
